import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const AuthContext = createContext(null);

const API = `${window.location.origin}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem("token"));

  const fetchUser = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data.user);
      setRestaurant(response.data.restaurant);
      setLoading(false);
    } catch (error) {
      console.error("Auth error:", error);
      localStorage.removeItem("token");
      setToken(null);
      setUser(null);
      setRestaurant(null);
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { token: newToken, user: userData, restaurant: restaurantData } = response.data;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser(userData);
    setRestaurant(restaurantData);
    return response.data;
  };

  const register = async (email, password, restaurantName) => {
    const response = await axios.post(`${API}/auth/register`, {
      email,
      password,
      restaurant_name: restaurantName
    });
    const { token: newToken, user: userData, restaurant: restaurantData } = response.data;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser(userData);
    setRestaurant(restaurantData);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    setRestaurant(null);
  };

  const updateRestaurant = (data) => {
    setRestaurant(prev => ({ ...prev, ...data }));
  };

  return (
    <AuthContext.Provider value={{
      user,
      restaurant,
      token,
      loading,
      login,
      register,
      logout,
      updateRestaurant,
      isAuthenticated: !!token
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
